<script>

export default {
  name: 'Dashboard',
};
</script>

<template>
  <v-flex>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue